(function () {
  'use strict';

  angular
    .module('perfis')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('root.perfis', {
        url: '/perfis',
        views: {
          'content@': {
            templateUrl: 'perfis/perfis.tpl.html',
            controller: 'PerfisCtrl',
            controllerAs: 'perfis'
          }
        },
        data: {
          titulo: 'core-permissoes.configuracoes.perfisDeUsuario.menuLabel',
          role: 'PERFIL_USUARIO_VISUALIZAR'
        }
      });
  }
}());
